import React, { useEffect, useState } from 'react';
import { Card, Button, Table, message, Space, Tag, InputNumber, Typography } from 'antd';
import { ReloadOutlined, PlusOutlined, CopyOutlined } from '@ant-design/icons';
import { createInvite, listInvites } from '../services/api';

const { Text } = Typography;

const InviteManagePage: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [invites, setInvites] = useState<Array<{ code: string; expires_at: string; active: boolean; used_by?: string; used_at?: string | null }>>([]);
  const [expireHours, setExpireHours] = useState<number>(24);

  const loadInvites = async () => {
    setLoading(true);
    try {
      const data = await listInvites();
      setInvites(data);
    } catch (e: any) {
      message.error(e?.response?.data?.detail || '加载邀请码失败');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadInvites();
  }, []);

  const handleCreate = async () => {
    setLoading(true);
    try {
      const res = await createInvite(expireHours);
      await loadInvites();
      message.success(`已生成邀请码：${res.code}`);
      try {
        await navigator.clipboard.writeText(res.code);
        message.info('邀请码已复制到剪贴板');
      } catch {}
    } catch (e: any) {
      message.error(e?.response?.data?.detail || '生成邀请码失败');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: 16 }}>
      <Card title="邀请码管理" extra={
        <Space>
          <Text>有效期(小时)</Text>
          <InputNumber min={1} max={24 * 30} value={expireHours} onChange={(v) => setExpireHours(Number(v || 1))} />
          <Button type="primary" icon={<PlusOutlined />} onClick={handleCreate} loading={loading}>生成邀请码</Button>
          <Button icon={<ReloadOutlined />} onClick={loadInvites} loading={loading}>刷新</Button>
        </Space>
      }>
        <Table
          rowKey={(r) => r.code}
          loading={loading}
          dataSource={invites}
          pagination={{ pageSize: 10 }}
          columns={[
            { title: '邀请码', dataIndex: 'code', key: 'code', render: (code: string) => (
              <Space>
                <Text code>{code}</Text>
                <Button size="small" icon={<CopyOutlined />} onClick={() => navigator.clipboard.writeText(code)}>复制</Button>
              </Space>
            )},
            { title: '有效期至', dataIndex: 'expires_at', key: 'expires_at', render: (t: string) => new Date(t).toLocaleString() },
            { title: '状态', dataIndex: 'active', key: 'active', render: (a: boolean) => a ? <Tag color="green">未使用</Tag> : <Tag>已使用/失效</Tag> },
            { title: '使用者', dataIndex: 'used_by', key: 'used_by', render: (v?: string) => v || '-' },
            { title: '使用时间', dataIndex: 'used_at', key: 'used_at', render: (t?: string) => t ? new Date(t).toLocaleString() : '-' },
          ]}
        />
      </Card>
    </div>
  );
};

export default InviteManagePage;
